import React from 'react';
import { AuthenticatedTemplate } from './AuthenticatedTemplate';
import { AuthorizationTemplate } from './AuthorizationTemplate';
import config from '../../config';
import { getLanguageFromLocaleString } from '../../core/helpers/configUtils';
import { LoadingOverlay } from '../components/LoadingOverlay';
import { useIsAuthenticated, useMsal } from '@azure/msal-react';
import { InteractionStatus } from '@azure/msal-browser';
import { Settings } from 'luxon';

export const App = () => {
    const language = getLanguageFromLocaleString(config.language);
    const { instance, inProgress, accounts } = useMsal();
    const isAuthenticated = useIsAuthenticated();
    Settings.defaultLocale = language;

    if (inProgress !== InteractionStatus.None) {
        return <LoadingOverlay pending={true} errorMessage="" />;
    }

    if (!isAuthenticated) {
        return <AuthorizationTemplate />;
    }
    instance.setActiveAccount(accounts[0]);
    return <AuthenticatedTemplate />;
};
